const readAsText = (file, encoding) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result || ""));
  reader.onerror = () => reject(reader.error || new Error("Fișierul nu a putut fi citit."));
  reader.readAsText(file, encoding);
});

const readAsArrayBuffer = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(reader.error || new Error("Fișierul nu a putut fi citit."));
  reader.readAsArrayBuffer(file);
});

const escapeHtml = (value) => String(value)
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#039;");

const textToHtml = (text) => String(text || "")
  .split(/\r?\n+/)
  .map((line) => line.trim())
  .filter((line) => line.length > 0)
  .map((line) => `<p>${escapeHtml(line)}</p>`)
  .join("");

const stripControlCharacters = (value) => Array.from(String(value || ""))
  .map((character) => {
    const code = character.charCodeAt(0);
    return code < 32 && code !== 9 && code !== 10 && code !== 13 ? " " : character;
  })
  .join("");

const cleanLegacyDocText = (value) => stripControlCharacters(value)
  .replace(/[ \t]{2,}/g, " ")
  .split(/\r?\n/)
  .map((line) => line.trim())
  .filter((line) => /[A-Za-zĂÂÎȘȚăâîșț]{2}/.test(line) && line.length < 5000)
  .join("\n");

const scoreText = (value) => {
  const text = String(value || "");
  const letters = (text.match(/[A-Za-zĂÂÎȘȚăâîșț]/g) || []).length;
  return letters - Math.max(0, text.length - letters * 8);
};

const extractLegacyDoc = async (file) => {
  const arrayBuffer = await readAsArrayBuffer(file);
  const bytes = new Uint8Array(arrayBuffer);
  const western = cleanLegacyDocText(new TextDecoder("windows-1252").decode(bytes));
  const unicode = cleanLegacyDocText(new TextDecoder("utf-16le").decode(bytes));
  const extracted = scoreText(unicode) > scoreText(western) ? unicode : western;

  if (extracted.length < 20) {
    throw new Error("Documentul .doc este protejat sau folosește un format binar care nu poate fi citit local.");
  }

  return textToHtml(extracted);
};

export const importDocumentAsHtml = async (file) => {
  const extension = file.name.split(".").pop().toLowerCase();

  if (extension === "txt") return textToHtml(await readAsText(file, "UTF-8"));
  if (extension === "doc") return extractLegacyDoc(file);
  if (extension === "docx") {
    const mammoth = await import("mammoth");
    const result = await mammoth.convertToHtml({ arrayBuffer: await readAsArrayBuffer(file) });
    return result.value;
  }

  throw new Error("Formatul selectat nu este acceptat.");
};
